import { modifyToInstance } from '../../lib/Formatter';
import * as actionTypes from './actionTypes';
import * as baseAction from './baseAction';

export const reportStart = (accessToken, data) => baseAction.actionStart(actionTypes.REPORT_START, accessToken, data);
export const reportSuccess = (data) => baseAction.actionSuccess(actionTypes.REPORT_SUCCESS, data);
export const reportFail = (error) => baseAction.actionFail(actionTypes.REPORT_FAIL, error);

export const reportSelect = (options) => {
    return (dispatch, getState) => {
        if (options && options.reportId) {
            baseAction.actionExecute(dispatch, getState, {
                url: `/Report/${options.reportId}`,
                startFn: (accessToken) => dispatch(reportStart(accessToken, { lastScope: 'select' })),
                successFn: (response) => dispatch(reportSuccess({ report: response.data, isNew: false })),
                failFn: (error) => dispatch(reportFail(error))
            });
        } else {
            dispatch(reportSuccess({ report: null, isNew: true }));
        }
    };
};


export const reportLogReport = (options) => {
    return (dispatch, getState) => {
        baseAction.actionExecute(dispatch, getState, {
            type: 'create',
            url: '/Report/LogReport',
            payload: sanitizeData(options.data),
            startFn: (accessToken) => dispatch(reportStart(accessToken, { lastScope: 'create' })),
            successFn: (response) => dispatch(reportSuccess({ report: response.data, isNew: false })),
            failFn: (error) => dispatch(reportFail(error))
        });
    };
};


export const reportCreate = (options) => {
  return (dispatch, getState) => {
      baseAction.actionExecute(dispatch, getState, {
          type: 'create',
          url: '/Report',
          payload: sanitizeData(options.data),
          startFn: (accessToken) => dispatch(reportStart(accessToken, { lastScope: 'create' })),
          successFn: (response) => dispatch(reportSuccess({ report: response.data, isNew: false })),
          failFn: (error) => dispatch(reportFail(error))
      });
  };
};

export const reportUpdate = (options) => {  
    return (dispatch, getState) => {
        baseAction.actionExecute(dispatch, getState, {
            type: 'update',
            url: `/Report/${options.reportId}`,
            payload: sanitizeData(options.data),
            startFn: (accessToken) => dispatch(reportStart(accessToken, { lastScope: 'update' })),
            successFn: (response) => dispatch(reportSuccess({ report: response.data, isNew: false })),
            failFn: (error) => dispatch(reportFail(error))
        });
    };
};

export const reportList = (options) => {
    return (dispatch, getState) => {
        let url = '/Report';
        if (options && options.applicationId) {
            url = `/Report/App/${options.applicationId}`;
        }
        baseAction.actionExecute(dispatch, getState, {
            url: url,
            startFn: (accessToken) => dispatch(reportStart(accessToken, { lastScope: 'list' })),
            successFn: (response) => {
                let result = response.data;
                if (Boolean(result && result.length)) {
                    result = result.map(data => {
                        if (data && data.name) {
                            data.name = modifyToInstance(data.name);
                        }
                        return {
                            ...data
                        }
                    })
                }
                dispatch(reportSuccess({ reports: result }))
            },
            failFn: (error) => dispatch(reportFail(error))
        });
    };
};

export const reportFranchiseList = (options) => {
    return (dispatch, getState) => {
        baseAction.actionExecute(dispatch, getState, {
            url: `/Report/GetSelectedFranchises/${options.reportId}`,
            startFn: (accessToken) => dispatch(reportStart(accessToken, { lastScope: 'list' })),
            successFn: (response) => dispatch(reportSuccess({ reportFranchises:  response.data })),
            failFn: (error) => dispatch(reportFail(error))
        });
    };
};

export const updateReportFranchiseList = (options) => {
  return (dispatch, getState) => {
    baseAction.actionExecute(dispatch, getState, {
      type: 'create',
      url: `/Report/SetSelectedFranchises/${options.reportId}`,
      payload: sanitizeData(options.data),
      startFn: (accessToken) => dispatch(reportStart(accessToken, { lastScope: 'list' })),
      successFn: (response) => dispatch(reportSuccess({ reportFranchises:  response.data })),
      failFn: (error) => dispatch(reportFail(error))
    });
  };
};

export const reportApplicationList = (options) => {
  return (dispatch, getState) => {
    baseAction.actionExecute(dispatch, getState, {
      url: `/Report/GetSelectedApps/${options.reportId}`,
      startFn: (accessToken) => dispatch(reportStart(accessToken, { lastScope: 'list' })),
      successFn: (response) => dispatch(reportSuccess({ reportApplications:  response.data })),
      failFn: (error) => dispatch(reportFail(error))
    });
  };
};

export const updateReportApplicationList = (options) => {
  return (dispatch, getState) => {
    baseAction.actionExecute(dispatch, getState, {
      type: 'create',
      url: `/Report/SetSelectedApps/${options.reportId}`,
      payload: sanitizeData(options.data),
      startFn: (accessToken) => dispatch(reportStart(accessToken, { lastScope: 'list' })),
      successFn: (response) => dispatch(reportSuccess({ reportApplications:  response.data })),
      failFn: (error) => dispatch(reportFail(error))
    });
  };
};

const sanitizeData = (value) => {
  if (value) {
    
  }

  return value;
};